import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styles from "./LoyaltyRewardBrandRefresh.module.css";

function RewardsTitleModal({ title, titleId, onClose }) {
  const closeButton = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButton.current.focus();
    const onKeyDown = event => {
      if (event.key === "Escape") onClose();
      if (event.key === "Tab") {
        event.preventDefault();
        closeButton.current.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    };
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className={styles.titleModalBackdrop}>
      <button type="button" className={styles.titleModalDismiss} tabIndex={-1} aria-hidden="true" aria-label="Dismiss offer title backdrop" onClick={onClose} />
      <div className={styles.titleModalContent} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <div className={styles.titleModalHeader}>
          <button ref={closeButton} type="button" className={styles.titleModalClose} aria-label="Close offer title" onClick={onClose}>
            <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18.75 5.25L5.25 18.75M18.75 18.75L5.25 5.25" stroke="#3B0055" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <p id={titleId} className={styles.titleModalText}>{title}</p>
      </div>
    </div>, document.body
  );
}

RewardsTitleModal.propTypes = {
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default RewardsTitleModal;
